// Map Layers Module - provides a clean API for managing map layers
// Private layer references - dynamically populated
const layers = {};

// Generic function to setup zoning layers
function setupZoningLayers(map, layerName, groupName, fillColor, textField, sourceLayer, filter, fillOpacity, minZoom, hitLayer, strokeWidth, renderPolygon, maxZoom) {
    // Initialize layer group if it doesn't exist
    if (!layers[groupName]) {
        layers[groupName] = {
            polygon: null,
            line: null,
            label: null
        };
    }
    var mapLayerName = layerName;
    if (hitLayer) {
        mapLayerName = mapLayerName + '_hit';
    }
    // Use defaults if not provided
    const opacity = fillOpacity !== undefined ? fillOpacity : 0.2;
    const zoom = minZoom !== undefined ? minZoom : 1;
    const stroke = strokeWidth !== undefined ? strokeWidth : 2.0;
    const showPolygon = renderPolygon !== undefined ? renderPolygon : true;

    // Create vector tile source
    //const vectorTileSource = new atlas.source.VectorTileSource(mapLayerName, {
    //    //tiles: [location.origin + '/tiles/pbftile/' + layerName + '/{z}/{x}/{y}.pbf'],
    //    tiles: [
    //        'https://byrightmaps.blob.core.windows.net/northcarolina/nhc/' + layerName + '/{z}/{x}/{y}.pbf'
    //        //'https://byright-fjgjhcbmdehsfach.z03.azurefd.net/northcarolina/nhc/' + layerName + '/{z}/{x}/{y}.pbf'
    //    ],
    //    minZoom: zoom,
    //    maxZoom: 20
    //});
    const TILE_VERSION = "v2026-01-12"; // bump this when you publish new tiles
    const MAP_TILES_BASE_URL = window.mapTilesBaseUrl || "https://byright-fjgjhcbmdehsfach.z03.azurefd.net";
    const MAP_TILES_IS_VERSIONED = window.mapTilesIsVersioned !== undefined ? window.mapTilesIsVersioned : true;

    // Build tile URL with or without version based on configuration
    const versionPath = MAP_TILES_IS_VERSIONED ? `${TILE_VERSION}/` : '';
    const tileUrl = `${MAP_TILES_BASE_URL}/northcarolina/nhc/${versionPath}${layerName}/{z}/{x}/{y}.pbf`;

    const vectorTileSource = new atlas.source.VectorTileSource(mapLayerName, {
        tiles: [tileUrl],
        minZoom: zoom,
        maxZoom: 20
    });
    map.sources.add(vectorTileSource);

    // Create polygon layer options
    const polygonLayerOptions = {
        id: groupName + '-zoning-fill',
        sourceLayer: sourceLayer,
        fillColor: fillColor,
        fillOpacity: opacity,
        visible: !hitLayer  // Hit layers are off by default
    };





    const linelayerOptions = {
        id: groupName + '-zoning-lines',
        sourceLayer: sourceLayer,
        strokeColor: '#ffffff',
        strokeWidth: stroke
    }

    // Create symbol/label layer
    const labelLayerOptions = {
        id: groupName + '-zoning-labels',
        sourceLayer: sourceLayer,
        filter: ['any',
            ['==', ['geometry-type'], 'Polygon'],
            ['==', ['geometry-type'], 'MultiPolygon']
        ],
        iconOptions: { image: 'none' },
        textOptions: {
            textField: textField,
            size: 12,
            haloColor: '#fff',
            haloWidth: 1.5,
            offset: [0, 1.2]
        }
    };
    // Add filter only if provided
    if (filter) {
        polygonLayerOptions.filter = filter;
        labelLayerOptions.filter = filter;
        linelayerOptions.filter = filter;
    }

    // Only show labels at high zoom levels for the 4 main zoning layers
    if (layerName === 'TOWB_ZoningLayer' ||
        layerName === 'TOCB_ZoningLayer' ||
        layerName === 'NHC_ZoningLayer' ||
        layerName === 'WILMINGTON_ZoningLayer') {
        labelLayerOptions.minZoom = 13; // Only show labels when almost fully zoomed in
        //linelayerOptions.strokeWidth = 1.5;
        //linelayerOptions.strokeColor = '#AF69EE';
        linelayerOptions.minZoom = 13;
        linelayerOptions.maxZoom = 15;
    }

    // Apply maxZoom if provided
    if (maxZoom !== undefined) {
        polygonLayerOptions.maxZoom = maxZoom;
        linelayerOptions.maxZoom = maxZoom;
        labelLayerOptions.maxZoom = maxZoom;
    }

    const labelLayer = new atlas.layer.SymbolLayer(mapLayerName, groupName + '-zoning-labels', labelLayerOptions);
    // Create line layer
    const lineLayer = new atlas.layer.LineLayer(mapLayerName, groupName + '-zoning-lines', linelayerOptions);
    const polygonLayer = new atlas.layer.PolygonLayer(mapLayerName, groupName + '-zoning-fill', polygonLayerOptions);

    // Only add polygon layer if renderPolygon is true
    if (showPolygon) {
        map.layers.add(polygonLayer);
    }
    map.layers.add(lineLayer);
    map.layers.add(labelLayer);

    // For hit layers, set all layers to invisible by default
    if (hitLayer) {
        if (polygonLayer) {
            polygonLayer.setOptions({ visible: false });
        }
        lineLayer.setOptions({ visible: false });
        labelLayer.setOptions({ visible: false });
    }

    // Store references
    layers[groupName].polygon = showPolygon ? polygonLayer : null;
    layers[groupName].line = lineLayer;
    layers[groupName].label = labelLayer;

    // Store original fill color and opacity for main zoning + overlay layers so we can restore when toggling
    // Overlay layers (1945, historic, height) use 0.01 when off so they stay queryable by getRenderedShapes
    if (layerName === 'TOWB_ZoningLayer' ||
        layerName === 'TOCB_ZoningLayer' ||
        layerName === 'NHC_ZoningLayer' ||
        layerName === 'WILMINGTON_ZoningLayer' ||
        layerName === 'TOCB_HeightOverlayDistrict' ||
        layerName === 'WILMINGTON_HistoricDistrictLayer' ||
        layerName === 'WILMINGTON_1945Layer') {
        layers[groupName].originalFillColor = fillColor;
        layers[groupName].originalFillOpacity = opacity;
    }
}

// Public API
const MapLayers = {
    setupNHCBaseMapLayers: function (map) {
        const TILE_VERSION = "v2026-01-12"; // bump this when you publish new tiles
        const MAP_TILES_BASE_URL = window.mapTilesBaseUrl || "https://byright-fjgjhcbmdehsfach.z03.azurefd.net";
        const MAP_TILES_IS_VERSIONED = window.mapTilesIsVersioned !== undefined ? window.mapTilesIsVersioned : true;

        // Build tile URL with or without version based on configuration
        const versionPath = MAP_TILES_IS_VERSIONED ? `${TILE_VERSION}/` : '';
        const tileUrl = `${MAP_TILES_BASE_URL}/northcarolina/nhc/${versionPath}NHC_BaseMap/{z}/{x}/{y}.pbf`;

        const vectorTileSource = new atlas.source.VectorTileSource('NHC_BaseMap', {
            tiles: [
                tileUrl
            ],
            minZoom: 1,
            maxZoom: 20
        });

        map.sources.add(vectorTileSource);

        const labelLayerOptions = {
            id: 'basemap_nhc-zoning-labels',
            //minZoom: 14,
            sourceLayer: 'lines',
            minZoom: 14,                    // labels usually start later to reduce clutter
            placement: 'line',
            lineSpacing: 250,          // smaller = more repeats (try 150–400)

            iconOptions: {
                image: 'none'
            },

            textOptions: {
                textField: ['coalesce', ['get', 'name'], ['get', 'ref']],
                rotationAlignment: 'map',

                // Make labels show up more often
                allowOverlap: true,      // show even if colliding :contentReference[oaicite:1]{index=1}
                ignorePlacement: true,   // let others collide with it :contentReference[oaicite:2]{index=2}
                padding: 1,              // smaller collision box

                size: ['interpolate', ['linear'], ['zoom'], 14, 11, 18, 16],
                color: '#555',
                haloColor: 'rgba(255,255,255,0.9)',
                haloWidth: 2
            }
        };
        const waterwetlandPolygonLayerOptions = {
            id: 'basemap_nhc_water' + '-zoning-fill',
            sourceLayer: 'polygons',
            //fillColor: '#12263a',
            fillOpacity: 1,
            //filter: [
            //    "any",
            //    ["==", ["get", "natural"], "water"],
            //    ["==", ["get", "natural"], "wetland"]
            //],
            fillColor: [
                'match',
                ['coalesce', ['get', 'natural'], ['get', 'landuse']],

                // beaches / dunes
                'sand', '#b99a5a',
                'beach', '#b99a5a',

                // vegetation
                'wood', '#2f5f3a',
                'forest', '#2f5f3a',

                // grass
                'grass', '#4f6b3a',
                'grassland', '#4f6b3a',
                'meadow', '#4f6b3a',

                // water
                'water', '#1b3a57',
                'wetland', '#2a5a54',

                // scrub / misc
                'scrub', '#3f5b3b',
                'heath', '#6a6b3a',
                'bare_rock', '#5c5c5c',
                'scree', '#6b6b6b',
                'shingle', '#8a7a6a',
                'mud', '#5b4a3a',

                // default
                'rgba(0,0,0,0)'
            ],

            visible: true
        };
        const buildingPolygonLayerOptions = {
            id: 'basemap_nhc_building-zoning-fill',
            sourceLayer: 'polygons',
            minZoom: 15,
            fillColor: '#6E6F71',
            fillOpacity: 1,
            filter: ["has", "building"],
            visible: true
        };

        const muniPolygonlayerOptions = {
            id: 'basemap_nhc_muni-zoning-fill',
            sourceLayer: 'polygons',
            visible: true,
            fillOpacity: 1,
            fillColor: [
                'match',
                ['get', 'name'],
                //'Wrightsville Beach', 'rgb(255, 255, 0, 0.5)',
                //'Wilmington', 'rgb(0, 200, 100, 0.5)',
                //'Carolina Beach', 'rgb(140, 26, 255, 0.5)',
                //'Kure Beach', '#6b5a7a',
                'New Hanover County', 'rgb(211,211,211, 0.2)',
                /* default */
                'rgba(0,0,0,0)'
            ],
        }
        //const lineLayer = new atlas.layer.LineLayer('NHC_BaseMap', 'nhcbasemap' + '-zoning-lines', linelayerOptions);
        const labelLayer = new atlas.layer.SymbolLayer('NHC_BaseMap', 'basemap_nhc-zoning-labels', labelLayerOptions);
        const waterWetlandPolygonLayer = new atlas.layer.PolygonLayer('NHC_BaseMap', 'basemap_nhc_water-zoning-fill', waterwetlandPolygonLayerOptions);
        const buildingPolygonLayer = new atlas.layer.PolygonLayer('NHC_BaseMap', 'basemap_nhc_building-zoning-fill', buildingPolygonLayerOptions);
        const muniPolygonLayer = new atlas.layer.PolygonLayer('NHC_BaseMap', 'basemap_nhc_muni-zoning-fill', muniPolygonlayerOptions);
        const ROAD_WIDTH = (z11, z14, z16, z18) => ([
            'interpolate', ['linear'], ['zoom'],
            11, z11,
            14, z14,
            16, z16,
            18, z18
        ]);
        function ROAD_OPACITY() {
            return [
                'interpolate', ['linear'], ['zoom'],

                // Low zoom: majors only
                10, ['match', ['get', 'highway'],
                    MAJOR_HWY, 0.9,
                    0.0
                ],

                // Mid zoom: minors start appearing
                13, ['match', ['get', 'highway'],
                    MAJOR_HWY, 0.95,
                    0.25
                ],

                // High zoom: everything visible
                15, 1.0
            ];
        }
        const MAJOR_HWY = [
            'motorway', 'trunk', 'primary',
            'motorway_link', 'trunk_link', 'primary_link'
        ];

        const MINOR_HWY = [
            'secondary', 'tertiary',
            'residential', 'unclassified', 'service',
            'secondary_link', 'tertiary_link'
        ];

        function ROAD_OPACITY() {
            return [
                'interpolate', ['linear'], ['zoom'],

                10, ['match', ['get', 'highway'],
                    MAJOR_HWY, 0.9,
                    0.0
                ],

                13, ['match', ['get', 'highway'],
                    MAJOR_HWY, 0.95,
                    0.25
                ],

                15, 1.0
            ];
        }

        function makeRoadLineLayer(id, highwayValues, color, widthExpr) {
            return new atlas.layer.LineLayer('NHC_BaseMap', id, {
                sourceLayer: 'lines',
                minZoom: 10,

                lineJoin: 'round',
                lineCap: 'round',

                strokeColor: color,
                strokeWidth: widthExpr,
                strokeOpacity: ROAD_OPACITY(),

                // ✅ Correct membership filter
                filter: ['in', ['get', 'highway'], ['literal', highwayValues]]

            });
        }

        const primaryCasing = makeRoadLineLayer(
            'basemap_nhc_road-primary-casing',
            MAJOR_HWY,
            '#5f5f5f',
            ROAD_WIDTH(2.0, 4.0, 6.5, 9.5)
        );

        const primaryFill = makeRoadLineLayer(
            'basemap_nhc_road-primary-fill',
            MAJOR_HWY,
            '#7a7a7a',
            ROAD_WIDTH(1.4, 3.0, 5.2, 8.0)
        );

        const resCasing = makeRoadLineLayer(
            'basemap_nhc_road-res-casing',
            MINOR_HWY,
            '#5f5f5f',
            ROAD_WIDTH(1.4, 2.6, 4.0, 6.0)
        );

        const resFill = makeRoadLineLayer(
            'basemap_nhc_road-res-fill',
            MINOR_HWY,
            '#7a7a7a',
            ROAD_WIDTH(1.0, 2.0, 3.2, 4.8)
        );



        map.layers.add(muniPolygonLayer);

        map.layers.add(waterWetlandPolygonLayer);
        map.layers.add(buildingPolygonLayer);

        map.layers.add([primaryCasing, primaryFill, resCasing, resFill]);
        map.layers.add(labelLayer);

    },
    setupNHCWetLandsLayers: function (map) {
        const TILE_VERSION = "v2026-01-12"; // bump this when you publish new tiles
        const MAP_TILES_BASE_URL = window.mapTilesBaseUrl || "https://byright-fjgjhcbmdehsfach.z03.azurefd.net";
        const MAP_TILES_IS_VERSIONED = window.mapTilesIsVersioned !== undefined ? window.mapTilesIsVersioned : true;

        // Build tile URL with or without version based on configuration
        const versionPath = MAP_TILES_IS_VERSIONED ? `${TILE_VERSION}/` : '';
        const tileUrl = `${MAP_TILES_BASE_URL}/northcarolina/nhc/${versionPath}NHC_WetLands/{z}/{x}/{y}.pbf`;

        const vectorTileSource = new atlas.source.VectorTileSource('NHC_WetLands', {
            tiles: [
                tileUrl
            ],
            minZoom: 1,
            maxZoom: 20
        });

        map.sources.add(vectorTileSource);

        const polygonLayerOptions = {
            id: 'wetlands-fill',
            sourceLayer: 'wetlands',
            visible: true,
            fillOpacity: 1,
            fillColor: [
                'match',
                ['get', 'WETLAND_TYPE'],
                'Estuarine and Marine Deepwater', '#1F4E79',
                'Estuarine and Marine Wetland', '#2E8BC0',
                'Freshwater Emergent Wetland', '#7BC96F',
                'Freshwater Forested/Shrub Wetland', '#2a5a54', //
                'Freshwater Pond', '#5DADE2',
                'Lake', '#2874A6',
                'Riverine', '#4A90A4',
                /* default */
                'rgba(0,0,0,0)'
            ],
        }
        const muniPolygonLayer = new atlas.layer.PolygonLayer('NHC_WetLands', 'wetlands-fill', polygonLayerOptions);
        map.layers.add(muniPolygonLayer);

        // Register the layer in the layers object for toggling
        if (!layers['NHC_WetLands']) {
            layers['NHC_WetLands'] = {
                polygon: muniPolygonLayer,
                line: null,
                label: null
            };
        }

        // Hide wetlands layer by default
        if (layers['NHC_WetLands'] && layers['NHC_WetLands'].polygon) {
            layers['NHC_WetLands'].polygon.setOptions({ visible: false });
        }
    },
    setupTOWBZoningLayers: function (map) {
        setupZoningLayers(
            map,
            'TOWB_ZoningLayer',
            'towb',
            '#FFFF00',
            ['coalesce', ['get', 'name'], ''],
            'zoning',
            null
        );
    },

    setupTOCBZoningLayers: function (map) {
        setupZoningLayers(
            map,
            'TOCB_ZoningLayer',
            'tocb',
            'rgb(140, 26, 255)',
            ['coalesce', ['get', 'ZONE'], ''],
            'zoning',
            null
        );
    },
    setupTOCBHeightOverlayDistrictLayer: function (map) {
        setupZoningLayers(
            map,
            'TOCB_HeightOverlayDistrict',
            'tocb-heightoverlay',
            'rgb(0, 120, 60)',
            ['literal', 'Height Overlay District (45ft)'],
            'overlay',
            null
        );
    },
    setupNHCZoningLayers: function (map) {
        setupZoningLayers(
            map,
            'NHC_ZoningLayer',
            'nhc',
            'rgb(0, 150, 255)',
            ['coalesce', ['get', 'ZONING'], ''],
            'nhc_parcels',
            ['all',
                ['!=', ['get', 'ZONING'], 'CITY'],
                ['!=', ['get', 'ZONING'], 'WB'],
                ['!=', ['get', 'ZONING'], 'FF']
            ]
        );
    },
    setupNHCParcelsLayers: function (map) {
        setupZoningLayers(
            map,
            'NHC_ParcelsLayer',
            'nhc_parcels',
            'rgb(0, 150, 255)',
            ['coalesce', ['get', 'ZONING'], ''],
            'parcels',
            null,
            0,  // fillOpacity: 0 (no fill)
            15  // minZoom: 14
        );
    },
    setupNHCMuniLimitsLayers: function (map) {
        setupZoningLayers(
            map,
            'NHC_MuniLimits',
            'nhc_munilimits',
            'rgb(0, 150, 255)',
            ['coalesce', ['get', 'CITY'], ''],
            'munilimits',
            null,
            0,  // fillOpacity: 0 (no fill)
            6,  // minZoom: 6
            undefined, // hitLayer
            3,  // strokeWidth: 3
            false, // renderPolygon: false
            14  // maxZoom: 14
        );
    },
    setupWILMINGTONZoningLayers: function (map) {
        setupZoningLayers(
            map,
            'WILMINGTON_ZoningLayer',
            'wilmington',
            'rgb(0, 200, 100)',
            ['coalesce', ['get', 'Zoning'], ''],
            'zoning',
            null
        );
    },
    setupWILMINGTONHistoricLayer: function (map) {
        setupZoningLayers(
            map,
            'WILMINGTON_HistoricDistrictLayer',
            'wilmington-historic',
            'rgb(0, 120, 60)',
            ['literal', 'Wilmington Historic District'],
            'historic',
            null
        );
    },
    setupWILMINGTON1945Layer: function (map) {
        setupZoningLayers(
            map,
            'WILMINGTON_1945Layer',
            'wilmington-1945',
            'rgb(0, 120, 60)',
            ['literal', 'Wilmington 1945 Corporate City Limits'],
            'historic',
            ['==', ['get', 'OBJECTID'], 1805]
        );
    },
    setupNHCFloodLayers: function (map) {
        // Filter to exclude FLD_ZONE = 'X' AND ZONE_SUBTY = 'AREA OF MINIMAL FLOOD HAZARD'
        const filter = [
            '!',
            ['all',
                ['==', ['get', 'FLD_ZONE'], 'X'],
                ['==', ['get', 'ZONE_SUBTY'], 'AREA OF MINIMAL FLOOD HAZARD']
            ]
        ];

        // Text field that shows both FLD_ZONE and ZONE_SUBTY (if present)
        const textField = [
            'concat',
            ['coalesce', ['get', 'FLD_ZONE'], ''],
            ['case',
                ['has', 'ZONE_SUBTY'],
                ['concat', '\n', ['coalesce', ['get', 'ZONE_SUBTY'], '']],
                ''
            ]
        ];

        // Data-driven fill color based on FLD_ZONE and ZONE_SUBTY
        const fillColor = [
            'case',
            // FLD_ZONE = X, ZONE_SUBTY = "FLOODWAY": purple (check this first for specificity)
            ['all',
                ['==', ['get', 'FLD_ZONE'], 'X'],
                ['==', ['get', 'ZONE_SUBTY'], 'FLOODWAY']
            ],
            'rgb(128, 0, 128)',  // Purple
            // FLD_ZONE = X, ZONE_SUBTY contains "PCT ANNUAL CHANCE FLOOD HAZARD": Yellow
            // Check for X zone with ZONE_SUBTY that exists and is not FLOODWAY or "AREA OF MINIMAL FLOOD HAZARD"
            // This will catch "0.2 PCT ANNUAL CHANCE FLOOD HAZARD" and similar variations
            ['all',
                ['==', ['get', 'FLD_ZONE'], 'X'],
                ['has', 'ZONE_SUBTY'],
                ['!=', ['get', 'ZONE_SUBTY'], 'FLOODWAY'],
                ['!=', ['get', 'ZONE_SUBTY'], 'AREA OF MINIMAL FLOOD HAZARD']
            ],
            'rgb(255, 255, 0)',  // Yellow
            // FLD_ZONE = AE, ZONE_SUBTY = null/empty: light blue
            ['all',
                ['==', ['get', 'FLD_ZONE'], 'AE'],
                ['any',
                    ['!', ['has', 'ZONE_SUBTY']],
                    ['==', ['coalesce', ['get', 'ZONE_SUBTY'], ''], '']
                ]
            ],
            'rgb(173, 216, 230)',  // Light blue
            // FLD_ZONE = VE, ZONE_SUBTY = null/empty: dark blue
            ['all',
                ['==', ['get', 'FLD_ZONE'], 'VE'],
                ['any',
                    ['!', ['has', 'ZONE_SUBTY']],
                    ['==', ['coalesce', ['get', 'ZONE_SUBTY'], ''], '']
                ]
            ],
            'rgb(25, 25, 112)',  // Dark blue
            // Default color (original green)
            'rgb(0, 200, 100)'
        ];

        setupZoningLayers(
            map,
            'NHC_FloodLayer',
            'NHC_FloodLayer',
            fillColor,
            textField,
            'parcels', //This was a mistake, I forgot to change "parcels" to "flood" when running tippecanoe
            filter
        );

        // Hide flood layer by default
        if (layers['NHC_FloodLayer']) {
            if (layers['NHC_FloodLayer'].polygon) {
                layers['NHC_FloodLayer'].polygon.setOptions({ visible: false });
            }
            if (layers['NHC_FloodLayer'].line) {
                layers['NHC_FloodLayer'].line.setOptions({ visible: false });
            }
            if (layers['NHC_FloodLayer'].label) {
                layers['NHC_FloodLayer'].label.setOptions({ visible: false });
            }
        }
    },

    // Generic toggle function that works with any layer group
    toggleLayerGroup: function (groupName, visible) {
        const group = layers[groupName];
        if (!group) {
            console.warn(`Layer group '${groupName}' not found`);
            return;
        }

        // Special handling: use fillOpacity 0.01 when off so layer stays queryable by getRenderedShapes
        const queryableWhenOff = ['towb', 'tocb', 'nhc', 'wilmington', 'tocb-heightoverlay', 'wilmington-historic', 'wilmington-1945'];
        if (queryableWhenOff.includes(groupName) && group.polygon) {
            if (visible) {
                // Restore original fill color and opacity
                if (group.originalFillColor !== undefined && group.originalFillOpacity !== undefined) {
                    group.polygon.setOptions({
                        fillColor: group.originalFillColor,
                        fillOpacity: group.originalFillOpacity,
                        visible: true
                    });
                } else {
                    group.polygon.setOptions({ visible: true });
                }
            } else {
                // Set fill opacity to near-zero (0.01) to hide visually, but keep layer visible and queryable
                // Using 0.01 instead of 0 ensures the layer remains in the render pipeline and is queryable by getRenderedShapes
                // Keep the original fill color so the layer remains in the render pipeline
                group.polygon.setOptions({
                    fillOpacity: 0.01,
                    visible: true
                });
            }
            // Still toggle line and label layers normally
            if (group.line) {
                group.line.setOptions({ visible: visible });
            }
            if (group.label) {
                group.label.setOptions({ visible: visible });
            }
        } else {
            // Normal behavior for other layers
            Object.values(group).forEach(layer => {
                if (layer && layer !== group.originalFillColor && layer !== group.originalFillOpacity) {
                    layer.setOptions({ visible: visible });
                }
            });
        }
    },

    // Parse WKT string to extract polygon coordinate rings
    parseWktToPolygons: function (wkt) {
        if (!wkt || typeof wkt !== 'string') return [];

        // Handle MultiPolygon: MULTIPOLYGON(((lng lat,...)),((lng lat,...)))
        if (wkt.toUpperCase().startsWith('MULTIPOLYGON')) {
            // strip leading MULTIPOLYGON( and trailing )
            const inner = wkt.substring(wkt.indexOf('(') + 1, wkt.lastIndexOf(')'));
            // split polygons
            const polyStrings = inner.split(')),((').map(s => s.replace(/^[\(\s]+|[\)\s]+$/g, ''));
            return polyStrings.map(ps => {
                const coords = ps.split(',').map(c => {
                    const parts = c.trim().split(/\s+/);
                    return [parseFloat(parts[0]), parseFloat(parts[1])];
                }).filter(p => !isNaN(p[0]) && !isNaN(p[1]));
                return coords;
            }).filter(arr => arr.length > 2);
        }

        // Polygon: POLYGON((lng lat, lng lat, ...))
        if (wkt.toUpperCase().startsWith('POLYGON')) {
            const match = wkt.match(/POLYGON\s*\(\s*\((.*?)\)\s*\)/i);
            if (!match || !match[1]) return [];
            const coords = match[1].split(',').map(c => {
                const parts = c.trim().split(/\s+/);
                return [parseFloat(parts[0]), parseFloat(parts[1])];
            }).filter(p => !isNaN(p[0]) && !isNaN(p[1]));
            return coords.length > 2 ? [coords] : [];
        }
        return [];
    },

    // Ensure a polygon ring is closed (first point = last point)
    ensureClosedRing: function (ring) {
        if (!ring || ring.length === 0) return ring;
        const first = ring[0];
        const last = ring[ring.length - 1];
        const isClosed = Math.abs(first[0] - last[0]) < 1e-9 && Math.abs(first[1] - last[1]) < 1e-9;
        return isClosed ? ring : [...ring, first];
    },

    // Load and display zone polygons on the map
    loadZonePolygons: async function (map, municipalityId, zoning, zoneKey) {
        if (!map || typeof atlas === 'undefined') {
            return;
        }

        try {
            const resp = await ApiClient.get(`/api/Parcel/by-zone?zoning=${encodeURIComponent(zoning)}&municipalityId=${municipalityId}`);
            if (!resp.ok) {
                throw new Error('Error loading parcels');
            }
            const data = await resp.json();

            // Initialize zone tracking if needed
            if (!window.zonePolygons) {
                window.zonePolygons = {}; // Track polygons by zoneKey: { "1-R-3": [feature1, feature2, ...] }
            }
            if (!window.zoneHighlightSource) {
                window.zoneHighlightSource = new atlas.source.DataSource('zone-highlight-source');
                map.sources.add(window.zoneHighlightSource);
            }
            if (!window.zoneHighlightLayer) {
                window.zoneHighlightLayer = new atlas.layer.PolygonLayer(window.zoneHighlightSource, 'zone-highlight-layer', {
                    fillColor: 'rgba(0, 102, 204, 0.55)',
                    strokeColor: '#0066cc',
                    strokeWidth: 2
                });
                map.layers.add(window.zoneHighlightLayer);
            }

            // Store features for this zone
            const zoneFeatures = [];
            let featureIndex = 0;
            data.forEach(item => {
                if (!item.boundaryWkt) return;
                const polygons = this.parseWktToPolygons(item.boundaryWkt);
                polygons.forEach(ring => {
                    const closed = this.ensureClosedRing(ring);
                    if (closed.length < 4) return;
                    const poly = new atlas.data.Polygon([closed]);
                    const featureId = `${zoneKey}_${featureIndex++}`;
                    const feature = new atlas.data.Feature(poly, null, featureId);
                    window.zoneHighlightSource.add(feature);
                    zoneFeatures.push(featureId); // Store IDs instead of feature objects
                });
            });

            // Store feature IDs for this zone key so we can remove them later
            window.zonePolygons[zoneKey] = zoneFeatures;
        } catch (err) {
            console.error('Error loading parcels by zone:', err);
            throw err;
        }
    },

    // Remove zone polygons from the map
    removeZonePolygons: function (map, zoneKey) {
        if (!map || !window.zonePolygons || !window.zoneHighlightSource) {
            return;
        }

        const featureIds = window.zonePolygons[zoneKey];
        if (featureIds && featureIds.length > 0) {
            // Remove features by ID from data source
            featureIds.forEach(featureId => {
                window.zoneHighlightSource.remove(featureId);
            });
            // Clear from tracking
            delete window.zonePolygons[zoneKey];
        }
    },

    // Load and display filtered parcels based on permitted uses
    loadFilteredParcels: function (map, filterResults) {
        if (!map || typeof atlas === 'undefined' || !filterResults || filterResults.length === 0) {
            return;
        }

        try {
            // Color mapping for standardized statuses
            const statusColors = {
                'PBR': { fill: 'rgba(0, 102, 204, 0.55)', stroke: '#0066cc' }, // Blue (current)
                'PWS': { fill: 'rgba(26, 188, 156, 0.55)', stroke: '#1ABC9C' }, // Teal
                'SUP': { fill: 'rgba(243, 156, 18, 0.55)', stroke: '#F39C12' }, // Orange
                'SUPS': { fill: 'rgba(142, 68, 173, 0.55)', stroke: '#8E44AD' }, // Purple
                'CZ': { fill: 'rgba(192, 57, 43, 0.55)', stroke: '#C0392B' } // Magenta
            };

            // Group parcels by status
            const parcelsByStatus = {};
            filterResults.forEach(item => {
                if (!item.boundaryWkt) return;
                const status = item.standardizedStatus || 'PBR';
                if (!parcelsByStatus[status]) {
                    parcelsByStatus[status] = [];
                }
                parcelsByStatus[status].push(item);
            });

            // Create a layer for each status
            Object.keys(parcelsByStatus).forEach(status => {
                const colorConfig = statusColors[status] || statusColors['PBR'];
                const sourceId = `filtered-parcels-source-${status}`;
                const layerId = `filtered-parcels-layer-${status}`;

                // Initialize source if needed
                let source = map.sources.getById(sourceId);
                if (!source) {
                    source = new atlas.source.DataSource(sourceId);
                    map.sources.add(source);
                }

                // Initialize layer if needed
                let layer = map.layers.getLayerById(layerId);
                if (!layer) {
                    layer = new atlas.layer.PolygonLayer(source, layerId, {
                        fillColor: colorConfig.fill,
                        strokeColor: colorConfig.stroke,
                        strokeWidth: 2
                    });
                    map.layers.add(layer);
                }

                // Clear existing features for this status
                source.clear();

                // Process parcels for this status
                const parcels = parcelsByStatus[status];
                parcels.forEach(item => {
                    const polygons = this.parseWktToPolygons(item.boundaryWkt);
                    polygons.forEach(ring => {
                        const closed = this.ensureClosedRing(ring);
                        if (closed.length < 4) return;
                        const poly = new atlas.data.Polygon([closed]);
                        source.add(new atlas.data.Feature(poly));
                    });
                });
            });

            // Store status layer IDs for cleanup
            window.filteredParcelsLayerIds = Object.keys(parcelsByStatus).map(s => `filtered-parcels-layer-${s}`);
        } catch (err) {
            console.error('Error loading filtered parcels:', err);
            throw err;
        }
    },

    // Remove filtered parcels from the map
    removeFilteredParcels: function (map) {
        if (!map) {
            return;
        }

        try {
            // Remove all status-specific layers and sources
            if (window.filteredParcelsLayerIds) {
                window.filteredParcelsLayerIds.forEach(layerId => {
                    const layer = map.layers.getLayerById(layerId);
                    if (layer) {
                        map.layers.remove(layer);
                    }
                });
                window.filteredParcelsLayerIds = [];
            }

            // Also clean up any legacy single layer
            if (window.filteredParcelsSource) {
                window.filteredParcelsSource.clear();
            }
            if (window.filteredParcelsFeatureIds) {
                window.filteredParcelsFeatureIds = [];
            }
        } catch (err) {
            console.error('Error removing filtered parcels:', err);
        }
    },

    // Search permitted uses via API, returning simplified objects
    searchPermittedUses: async function (query, municipalityId = 1) {
        const q = (query || '').trim();
        if (!q) return [];
        try {
            const resp = await ApiClient.get(`/api/uses/search?q=${encodeURIComponent(q)}&municipalityId=${municipalityId}`);
            if (!resp.ok) {
                throw new Error(`HTTP ${resp.status}`);
            }
            const data = await resp.json();
            return Array.isArray(data)
                ? data
                    .map(item => ({
                        id: item.id || item.name,
                        name: item.name || ''
                    }))
                    .filter(item => item.name)
                : [];
        } catch (err) {
            console.debug('searchPermittedUses error:', err);
            return [];
        }
    },

    searchPermittedUsesByCategory: async function (category, municipalityId = 1) {
        if (!category) return [];
        try {
            const resp = await ApiClient.get(`/api/uses/by-category?category=${encodeURIComponent(category)}&municipalityId=${municipalityId}`);
            if (!resp.ok) {
                throw new Error(`HTTP ${resp.status}`);
            }
            const data = await resp.json();
            return Array.isArray(data)
                ? data
                    .map(item => ({
                        id: item.id || item.name,
                        name: item.name || ''
                    }))
                    .filter(item => item.name)
                : [];
        } catch (err) {
            console.debug('searchPermittedUsesByCategory error:', err);
            return [];
        }
    },

    // Extract parcel details from features for inspection panel
    // Also infers a municipalityId based on the source zoning layer.
    // Municipality IDs:
    // 1 = Wilmington, 2 = Carolina Beach, 3 = Wrightsville Beach, 4 = Kure Beach, 5 = New Hanover County
    extractParcelDetails: function (features) {
        const details = {
            acres: null,
            pid: null,
            zoningDistrict: null,
            municipalityId: null,
            isWithinHistoricDistrict: false,
            isWithinHistoric1945: false,
            isWithinHeightOverlay: false
        };

        if (!features || features.length === 0) {
            return details;
        }

        // Search through all features to find the properties
        for (let i = 0; i < features.length; i++) {
            const feature = features[i];
            const properties = feature.properties || {};
            const layerId = (feature.layer && feature.layer.id) ? feature.layer.id : '';

            // Extract ACRES
            if (details.acres === null && properties.ACRES !== null && properties.ACRES !== undefined) {
                details.acres = String(properties.ACRES);
            }

            // Extract PID
            if (details.pid === null && properties.PID !== null && properties.PID !== undefined) {
                details.pid = String(properties.PID);
            }

            // Infer municipalityId from the layer id if we haven't yet
            if (details.municipalityId === null && layerId) {
                if (layerId.includes('wilmington')) {
                    details.municipalityId = 1;
                } else if (layerId.includes('tocb')) {
                    details.municipalityId = 2;
                } else if (layerId.includes('towb')) {
                    details.municipalityId = 3;
                } else if (layerId.includes('kure')) {
                    details.municipalityId = 4;
                } else if (layerId.includes('nhc') && !layerId.includes('nhc_parcels-zoning-fill') && !layerId.includes('nhc_munilimits-zoning-fill') && !layerId.includes('nhc_parcels-zoning-lines')) {
                    // Exclude nhc_parcels-zoning-fill from municipality inference
                    details.municipalityId = 5;
                }
            }

            // Extract zoning district - check multiple possible property names based on layer
            // Different layers use different property names: 'name', 'ZONING', 'ZONE', 'Zoning'
            if (details.zoningDistrict === null) {
                // Check based on layer ID first for more accurate matching
                if (layerId.includes('towb')) {
                    // TOWB uses 'name'
                    if (properties.name !== null && properties.name !== undefined && properties.name !== '') {
                        details.zoningDistrict = String(properties.name);
                    }
                } else if (layerId.includes('tocb')) {
                    // TOCB uses 'ZONE'
                    if (properties.ZONE !== null && properties.ZONE !== undefined && properties.ZONE !== '') {
                        details.zoningDistrict = String(properties.ZONE);
                    }
                } else if (layerId.includes('nhc') || layerId.includes('wilmington')) {
                    // NHC uses 'ZONING', Wilmington uses 'Zoning'
                    if (properties.ZONING !== null && properties.ZONING !== undefined && properties.ZONING !== '') {
                        details.zoningDistrict = String(properties.ZONING);
                    } else if (properties.Zoning !== null && properties.Zoning !== undefined && properties.Zoning !== '') {
                        details.zoningDistrict = String(properties.Zoning);
                    }
                }

                // Fallback: check all property names if layer-based check didn't work
                if (details.zoningDistrict === null) {
                    if (properties.name !== null && properties.name !== undefined && properties.name !== '') {
                        details.zoningDistrict = String(properties.name);
                    } else if (properties.ZONING !== null && properties.ZONING !== undefined && properties.ZONING !== '') {
                        details.zoningDistrict = String(properties.ZONING);
                    } else if (properties.ZONE !== null && properties.ZONE !== undefined && properties.ZONE !== '') {
                        details.zoningDistrict = String(properties.ZONE);
                    } else if (properties.Zoning !== null && properties.Zoning !== undefined && properties.Zoning !== '') {
                        details.zoningDistrict = String(properties.Zoning);
                    }
                }
            }
        }

        return details;
    }
};

// Export for ES6 modules
export default MapLayers;

// Make it globally accessible for backward compatibility
window.MapLayers = MapLayers;

// Export for use in other files (maintains backward compatibility)
function setupNHCBaseMapLayers(map) {
    MapLayers.setupNHCBaseMapLayers(map);
}

function setupNHCWetLandsLayers(map) {
    MapLayers.setupNHCWetLandsLayers(map);
}
function setupTOWBZoningLayers(map) {
    MapLayers.setupTOWBZoningLayers(map);
}

function setupTOCBZoningLayers(map) {
    MapLayers.setupTOCBZoningLayers(map);
}

function setupTOCBHeightOverlayDistrictLayer(map) {
    MapLayers.setupTOCBHeightOverlayDistrictLayer(map);
}
function setupNHCZoningLayers(map) {
    MapLayers.setupNHCZoningLayers(map);
}
function setupNHCParcelsLayers(map) {
    MapLayers.setupNHCParcelsLayers(map);
}

function setupNHCMuniLimitsLayers(map) {
    MapLayers.setupNHCMuniLimitsLayers(map);
}
function setupWILMINGTONZoningLayers(map) {
    MapLayers.setupWILMINGTONZoningLayers(map);
}

function setupWILMINGTONHistoricLayer(map) {
    MapLayers.setupWILMINGTONHistoricLayer(map);
}
function setupWILMINGTON1945Layer(map) {
    MapLayers.setupWILMINGTON1945Layer(map);
}
function setupNHCFloodLayers(map) {
    MapLayers.setupNHCFloodLayers(map);
}

// Export helper functions for backward compatibility
export {
    setupNHCBaseMapLayers,
    setupTOWBZoningLayers,
    setupTOCBZoningLayers,
    setupTOCBHeightOverlayDistrictLayer,
    setupNHCZoningLayers,
    setupNHCParcelsLayers,
    setupNHCMuniLimitsLayers,
    setupWILMINGTONZoningLayers,
    setupWILMINGTONHistoricLayer,
    setupWILMINGTON1945Layer,
    setupNHCFloodLayers
};

